import React from 'react';
import { TableCell as BaseTableCell, TableCellProps } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { useCellStyles } from '../useCellStyles';


export function TableCell({inHead, ...props}: TableCellProps & {inHead?: boolean}) {
  const classes = useCellStyles();
  const StyledCell = withStyles(() => ({
    head: {
      backgroundColor: '#e9ecef',
      color: '#6a757a',
    },
    body: {
    },
  }))(BaseTableCell);

  return <StyledCell className={inHead ? classes.head : classes.cell} {...props}>{props.children}</StyledCell>;
}